export const CLI_KIT_VERSION = '4.6.1'
